import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=6eaf3696&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=ts&"
export * from "./Event.vue?vue&type=script&lang=ts&"
import style0 from "./Event.vue?vue&type=style&index=0&id=6eaf3696&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaf3696",
  null
  
)

export default component.exports